import { ReactText } from "react";
import { Slide, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import theme from "src/theme";

toast.configure();

export const notify = (message: string): void => {
  toast.dismiss();

  const newToast = (): ReactText =>
    toast(message, {
      transition: Slide,
      autoClose: 4000,
      closeButton: false,
      closeOnClick: true,
      draggable: true,
      hideProgressBar: true,
      pauseOnHover: true,
      position: "top-center",
      style: {
        background: theme.colors.gold,
        color: theme.colors.white,
        textAlign: "center",
        minHeight: 50,
      },
      bodyStyle: {
        fontSize: 15,
        fontFamily: theme.fonts.subtitle,
      },
    });

  setTimeout(newToast, 100);
};

export default { notify };
